import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';

function useCampaignNameCell(visibleColumns: any) {
  if (!visibleColumns.includes('campaignName')) {
    return null;
  }
  return {
    title: <TableHeader title={getI18n().t('Campaign Name', { ns: 'sales' })} />,
    dataIndex: ['campaignName'],
    key: 'campaignName',
    render: (campaignName: any) => <CellText>{campaignName}</CellText>,
    width: 150,
  };
}

export default useCampaignNameCell;
